<template lang="pug">
    v-app
        AppHeader
        v-main.mt-60
            v-container
                router-view
        AppFooter
</template>



<script>
    import AppHeader from '@/components/AppHeader.vue'
    import AppFooter from '@/components/AppFooter.vue'

    export default {
        components: {
            AppHeader,
            AppFooter
        }
    }
</script>

